import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';

import { selectSettingFrodoTimeouts } from 'src/app/stores/settings';

import { NavigationService } from '../../services/navigation/navigation.service';

@Component({
  selector: 'frodo-device-suspended',
  templateUrl: './device-suspended.component.html',
  styleUrls: ['./device-suspended.component.scss'],
})
export class DeviceSuspendedComponent implements OnInit, OnDestroy {
  private sessionTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(private store: Store, private navigationService: NavigationService) {}

  ngOnInit(): void {
    this.store
      .select(selectSettingFrodoTimeouts)
      .pipe(
        take(1),
        map((timeouts) => timeouts?.associateTimeout)
      )
      .subscribe((timeout) => {
        this.sessionTimeout = setTimeout(() => {
          this.navigationService.navigateToRootRoute();
        }, timeout);
      });
  }

  ngOnDestroy(): void {
    this.sessionTimeout && clearTimeout(this.sessionTimeout);
  }
}
